export const reportFolio = {
  "buttons": {
    "resend": "Reenviar",
    "clearSelection": "Limpiar selección"
  },
  "snackbar": {
    "sendReport": {
      "success": "El reporte se reenvió exitosamente",
      "ERR_NOT_FOUND": "Ocurrió un error al Reenviar el reporte"
    },
    "areYouSureonDeleteThisFile": "¿Estás seguro que quieres eliminar este archivo?",
    "deleteImage": "¿Estás seguro que quieres eliminar la imagen?",
    "deleteVideo": "¿Estás seguro que quieres eliminar el video?",
    "deleteSign": "¿Estás seguro que quieres eliminar la firma?",
    "deleteComment": "¿Estás seguro que quieres eliminar el comentario?",
    "deleteDocument": "¿Estás seguro que quieres eliminar el documento?",
    "fieldRequired": "Se encontraron campos sin completar",
    "lackOfEvidences": "Se requieren evidencias de tipo:",
    "reasonOfReject": "Es necesario ingresar un motivo de rechazo"
  },
  reassignStatus: {
    1: 'edición',
    2: 'reasignacion de área y departamento',
    4: 'cancelación',
  },
  "detail": {
    "general": {
      resendReport: "Reenviar reporte",
      timeConsumed:"Tiempo consumido",
      departmentWithoutCategories:"No hay categorías disponibles en el departamento seleccionado",
      remainingTime:"Tiempo restante",
      quote: "Cotización",
      noDateAvailable: "No hay una fecha disponible.",
      solutionProvider: "Solución del proveedor",
      dowloadQuote: "Descargar cotización",
      solutionDownload: "Descargar Solución",
      AprovedQuoteSucces: "Cotización aprobada con éxito",
      RejectQuoteSucces: "Cotización rechazada con éxito",
      noAssignedUser: "No hay un usuario asignado a este folio.",
      oppsError: "Opps.. ha ocurrido un error.",
      isWaitingResponseCuestionarieCompleted: "#{{Id}} - Versión: {{version}}  {{unidad}}  Agendado para: {{Date}} Resuelto el: {{DateSolve}}",
      isWaitingResponseCuestionarie: "#{{Id}} - Versión: {{version}}  {{unidad}}  Agendado para: {{Date}}",
      pleaseCompleteCuestionarie: "Por favor, completa el cuestionario de esta solicitud desde la aplicación mobile.",
      seeDetailQuote: "Ver detalle de la cotización",
      seeDetailSolution: 'Ver detalle de la solución',
      quotationTitle: 'Pedir cotización',
      quotationTitleProvider: 'Petición de cotización',
      solutionTitleProvider: 'Petición de solución',
      quotationTitleProviderSend: 'Petición de cotización enviada',
      quotationTitleProviderSendCancel: "Cotización rechazada",
      solutionTitleProviderSendCancel: 'Solución rechazada',
      quotationProviderSend: "Cotización enviada",
      solutionProviderSend: "Solución enviada",
      quotationTitleProviderSendApprove: "Cotización aprobada",
      solutionTitleProviderSendApprove: "Solución aprobada",
      quotationSendMessage: 'Se ha enviado la petición al proveedor, por favor espera a su respuesta. Recuerda que puedes contactarte con él usando los comentarios',
      confirmQuotationTitle: 'Solicitud de cotización',
      SatisfactionSurvey: "Encuesta de satisfacción",
      sendQuotationTitle: 'Envio de cotización',
      sendSolutionTitle: "Envio de solución",
      confirmQuotationTitleSucces: 'Solicitud de cotización enviada con éxito',
      confirmSolutionTitleError: 'Opps.. ocurrió un error en la solicitud de cotización',
      confirmQuotationTitleError: 'Opps.. ocurrió un error en la solicitud de solución',
      confirmSolutionTitleErrorApprove: 'Opps.. ocurrió un error en la solicitud de aprobación',
      confirmSolutionTitleSuccess: 'Solicitud de solución enviada con éxito',
      confirmSolutionTitleSuccessApprove: 'Aprobación de solución exitosa',
      confirmSolutionTitleSuccessReject: 'Rechazo de solución exitososo',
      confirmSendQuotationTitleSucces: 'Cotización enviada con éxito',
      confirmQuotationTitleError: 'No se pudo realizar la solicitud de cotización',
      confirmQuotationTitleErrorReject: 'No se pudo realizar la solicitud de rechazo',
      confirmQuotationDescription: '¿Estás seguro que deseas solicitar la cotización a {{provider}}?',
      confirmQuotationEvidences: '¿Estás seguro que deseas enviar la cotización?',
      confirmSolutionEvidences: '¿Estás seguro que deseas enviar la solución?',
      providerAssigned: "Usuario asignado : {{provider}}",
      providerAssigned: "Usuario asignado : {{provider}}",
      providerAssignedAndDate: "Enviada el: {{Date}}",
      providerAssignedAndDateAndReject: "Enviada el: {{Date}}  Rechazada: {{Rechazada}}",
      providerAssignedAndDateAndApprove: "Enviada el: {{Date}}  Aprobada: {{Rechazada}}",
      solutionTitle: 'Petición de solución',
      sentOn: 'Enviada el: {{fecha}}',
      approveOn: 'Aprobada el: {{fecha}}',
      rejectedOn: 'Rechazada el: {{fecha}}',
      generatedOn: 'Generada el: {{fecha}}',
      generatedBy: 'Por: {{provider}}',
      provider: 'Usuario asignado: {{provider}}',
      attend: 'Atender',
      quotationStatus: 'Cotización {{status}}',
      solutionStatus: 'Solución {{status}}',
      seeDetail: "Ver detalle",
      seeQuotationDetail: 'Ver detalle de la cotización',
      seeSolutionDetail: 'Ver detalle de la solución',
      downloadQuotation: 'Descargar cotización',
      seeSolutionDetail: 'Ver detalle de la solución',
      downloadSolution: 'Descargar solución',
      sendQuotationTitle: 'Enviar cotización',
      sendSolutionTitle: 'Enviar solución',
      sendSolutionApprove: 'Aprobar solución',
      sendSolutionReject: 'Rechazar solución',
      AttendquotationTitle: "Atender",
      quotationSendInfo: "Se ha enviado la cotización al encargado del departamento y al creador del folio, por favor espera su respuesta. Recuerda que puedes contactarte con él usando los comentarios",
      solutionSendInfo: "Se ha enviado la solución al encargado del departamento y al creador del folio, por favor espera su respuesta. Recuerda que puedes contactarte con él usando los comentarios",
      sendSolutionTitle: 'Enviar solución',
      quotatioDetail: 'Detalle de cotización',
      solutionDetail: 'Detalle de solución',
      solutionSent: 'Solución enviada',
      quotationSent: 'Cotización enviada',
      information: 'Información',
      evidencesDetail: 'Evidencias',
      approved: 'Aprobación',
      rejected: 'Rechazo',
      selectCategoryOrService: 'Seleccione la categoría o servicios de este mantenimiento',
      selectAreaAndDepartmet: 'Seleccione un área y un departamento para visualizar las categorías correspondientes.',
      sendQuotationDescription: 'Se ha solicitado cotización para la solicitud. Puedes agregar un comentario',
      sendSolutionDescription: 'Para la solución de esta solicitud por favor cargue las evidencias. Puedes agregar un comentario',
      sendSolutionApproveDescription: 'Para aprobar esta solicitud, por favor cargue las evidencias. Puedes agregar un comentario.',
      sendSolutionRejectDescription: 'Para rechazar esta solicitud, por favor cargue las evidencias. Puedes agregar un comentario.',
      "statuses": {
        "2": "enviada",
        "3": "rechazada",
        "4": "aprobada"
      },
      satisfactionSurvey: 'Encuesta de satisfacción',
      howDoYouEvaluateTheManagementOfThisFolio: '¿Cómo evalúa la gestiónb de este folio?',
      sentThisSolution: '¿Estás seguro que deseas enviar esta solución?',
      editFolio: '¿Estás seguro que deseas editar el folio?',
      cancelFolio: '¿Estás seguro que deseas cancelar el folio?',
      reassignUser: '¿Estás seguro que deseas reasignar el usuario?',
      reassignAreaAndDepartmentFolio: '¿Estás seguro que deseas reasignar el área y departamento?',
      reassignProviderConfirm: '¿Estás seguro que deseas reasignar el usuario asignado?',
      "answerReportFolio": "Solucionar folio",
      "mustAddedARejectReason": "Se debe agregar un motivo de rechazo",
      "mustAddedAApproveReason": "Se debe agregar un motivo de aprobación",
      "mustAddedARespondedReason": "Se debe agregar una descripción",
      "rejectReasonMustHaveThreeCharacters": "El motivo debe tener al menos {{size}} caracteres",
      "rejectReasonisMax": "El motivo no debe superar los {{size}} caracteres",
      "loadEvidences": "Cargar evidencias adjuntas",
      "noUsersAssigned": "No hay usuarios asignados",
      "userAssigned": "Usuarios asignados",
      "question": "Pregunta",
      "reject": "Rechazar",
      "approve": "Aprobar",
      rejectSolution: "Rechazar solución",
      approveSolution: "Aprobar solución",
      "Involucrated": "Involucrados",
      "send": "Enviar",
      "approveAndReject": "Aprobar y cerrar",
      "folioAmound": "#Folio",
      "description": "Descripción",
      "createrUser": "Usuario Creador",
      "createBy": "Creado por",
      "solveBy": "Aprobado por",
      "rejectedBy": "Rechazado por",
      "solution": "Solución",
      "unit": "Unidad",
      "unitID": "ID - Unidad",
      "reportFolioConfig" : "Configuración general de folios",
      "folioConfig" : "Configuración de Folio",
      "foliosIndicator" : "Indicador de folios",
      "area": "Área",
      "areaForm": "Área *",
      "providerForm": "Usuario asignado *",
      "GestionZone": "Zona de gestión",
      "department": "Dpto.",
      "deparmentFull": "Departamento",
      "fechainifin": "Fecha: Inicio-Fin",
      "deparmentFullForm": "Departamento *",
      category: 'Categoría',
      categoryFull: 'Categorización',
      subcategory: 'Subcategoría',
      "evidences": "evidencias",
      "comments": "Comentarios",
      "comment": "Comentario",
      commentTooLong: "Solo se permiten máximo 255 caracteres.",
      "video": "Videos",
      "noFound": "El componente no se encontró",
      "images": "Imágenes",
      "sign": "Firmas",
      "documents": "Documentos",
      "noInformation": "No hay información",
      "Waitingsolution": "Esperando solución",
      "ContactEncargado": "En la espera puedes contactarte con el encargado del departamento.",
      "noComments": "No hay comentarios disponibles.",
      "solutionFolder": "Solución de folio",
      "proccesFolder": "Procesar folio",
      "reassign": "Reasignar",
      "sendRating": "Responder raiting",
      "informFolio": "Informe de Folio",
      "wasSend": "Enviada el",
      "by": "por",
      detail: 'Detalle',
      "evidencesAttached": "Evidencias adjuntas",
      "rating": "Raiting",
      "solveEvidences": "Evidencias de solución",
      "rejectEvidences": "Evidencias de rechazo",
      "rejectReason": "Motivo de rechazo",
      "approveReason": "Motivo de aprobación",
      CancelationSucces: "Cancelación exitosa",
      noCancelAllFolios: "No todos los folios pudieron ser cancelados",
      errorToCancelMasive: "Error al cancelar",
      ReassignFolio: "Reasignación exitosa",
      noReassignAllFolios: "No todos los folios pudieron ser reasignados",
      foliosNotFound: "No se encontro folios del usuario logueado",
      foliaHasProcessed: "El folio no se puede reasignar porque ya esta siendo procesado",
      noFoliosCouldBeReassigned: "No se pudo reasignar ningun folio",
      errorToReasignMasive: "Error al reasignar",
      errorToDeleteMasive: "Error al eliminar",
      selectAtLeastOneFolio: "Debes seleccionar al menos 1 folio para realizar esta acción",
      EliminatationSucces: "Eliminación exitosa",
      confirmTitle: 'Confirmación',
      confirmQuoteDescription: "¿Estás seguro que deseas aprobar esta cotización?",
      confirmSolutionDescription: "¿Estás seguro que deseas aprobar esta solución?",
      rejectQuoteDescription: "¿Estás seguro que deseas rechazar esta cotización?",
      rejectSolutionDescription: "¿Estás seguro que deseas rechazar esta solución?",
      confirm: "Confirmar",
      cancel: "Cancelar",
      survey: "Encuesta de satisfacción",
      cancelMotive: "Motivo de la cancelación",
      folio: "folios",
      cancelMotiveText_one: "Por favor, indique el motivo por el cual se cancela el folio",
      cancelMotiveText_other: "Por favor, indique el motivo por el cual cancela {{countFolios}} folios.",
      cancelFolioConfirm: "Cancelar folio",
      reassignProvider: " Reasignación de usuario asignado",
      yourSelectionAffect_one: "Tu selección afectará {{countFolios}} folio",
      yourSelectionAffect_other: "Tu selección afectará {{countFolios}} folios",
      reassing: "Reasignar",
      CancelFolios_one: "¿Estás seguro que deseas eliminar el folio?",
      CancelFolios_other: "¿Estás seguro que deseas eliminar los folios seleccionados?",
      DeleteFolios_one: "¿Estás seguro que deseas cancelar el folio?",
      DeleteFolios_other: "¿Estás seguro que deseas cancelar los folios seleccionados?",
      reassignAreaAndDepartment: " Reasignación de área y departamento",
      motiveCancelFolioTitle: "Motivo de cancelación de folio",
      selectAndConfirm: "Seleccione y confirme la acción"
    },
    editReportFolio: {
      title: "Editar folio",
      describeAReason: "Describa el motivo por el cual se crea este folio.",
      message: {
        edit: "El folio se actualizó exitosamente"
      }
    },
    reassignAreaAndDepatmentReportFolio: {
      title: 'Reasignar área y departamento',
      message: {
        edit: "El área y el departamento se reasignaron exitosamente"
      }
    },
    reassignProviderSucces: {
      title: 'Reasignar proveedor',
      message: {
        edit: "El proveedor se reasigno exitosamente"
      }
    },
    cancel: {
      title: '¿Está seguro que desea cancelar este folio?',
      message: {
        edit: "El folio se canceló exitosamente"
      }
    },
    reassignUser: {
      title: 'Reasignar usuario',
      message: {
        edit: "El usuario se reasignó exitosamente"
      }
    },
    "buttonOptions": {
      "title": "¿Qué desea hacer con este folio?"
    },
    "approve": {
      "title": "¿Cómo le pareció la gestión de este folio?",
      "reason": "Indique el motivo por el cual aprueba este folio"
    },
    "reassign": {
      "title": "Reasignar folio",
      "search": "Buscar usuarios"
    },
    "reject": {
      "title": "Indique el motivo por el cual rechaza este folio"
    },
    "responded": {
      "title": "Indique la descripción de la solución dada a este folio"
    },
    "snackbar": {
      "reject": {
        "success": "El folio se rechazo exitosamente",
        "error": "Ocurrió un error al rechazar el folio"
      },
      "responded": {
        "success": "El folio se solucionó exitosamente",
        "error": "Ocurrió un error al solucionar el folio"
      },
      "approve": {
        "success": "El folio se aprobó exitosamente",
        "error": "Ocurrió un error al aprobar el folio"
      },
      "raiting": {
        "success": "El raiting se envió exitosamente",
        "error": "Ocurrió un error al enviar el raiting"
      },
      "reassign": {
        "success": "El folio se reasignó exitosamente",
        "error": "Ocurrió un error al reasignar el folio"
      }
    }
  },
  "modal": {
    "deleteCategori": "¿Estás seguro de que deseas eliminar esta categoría?",
    "confirmation": "Confirmación",
    "sendReport": {
      "title": "Reenviar reporte de folio",
      "titleVisit": "Reenviar reporte de visita",
      "titleQuestionnaire": "Reenviar reporte de cuestionario",
      "requestingUser": "Reenviar a usuario solicitante",
      "assignUser": "Reenviar a encargado del departamento",
      "userWhoResponded": "Reenviar a usuario que respondió el cuestionario",
      "userCreator": "Usuario planificador",
      "usersDirectParents": "Usuario jefe(s) directo(s) o administradores",
      "email": "Correos",
      "userAssign": "Usuario que respondió el cuestionario",
      "agentStore": "Reenviar a jefe directo del usuario asignado",
      "userSupervisor": "Reenviar a usuario(s) supervisor(es) de la visita",
      "userStore": "Reenviar a usuario(s) asignado(s) a la unidad",
      "emailStore": "Reenviar a la unidad",
      "externalEmails": "Usuarios externos",
      "01": "El envio no se pudo hacer efectivo para los siguientes usuarios",
      "emails": "Indique los correos a los que desea enviar el reporte, separados por coma.",
      "external": "Usuarios externos",
      "internal": "Usuarios internos"
    },
    "return": "¿Estás seguro que quieres regresar al listado?",
    "descriptionReturn": "Al regresar las configuraciones realizadas se perderán."
  },
  "dashboard": {
    "status": {
      "1": "Activo",
      "5": "Cancelado",
      "13": "Rechazado",
      "18": "En espera de aprobación",
      "19": "Aprobado",
      "20": "En espera de solución",
      "10": "Vencido sin solución",
      "21": "Vencido"
    },
    "table": {
      "priority": "Prioridad",
      "foliosAmount": "# de Folio",
      "unit": "Área - Departamento - Unidad - Usuario Solicitante",
      "usersAssigned": "Usuario(s) Asignado(s)",
      "bossAssigned": "Jefe directo",
      "areaDepartment": "Área / Departamento",
      "unitUser": "Unidad - ID",
      "requestDate": "Fecha solicitud",
      "solveDate": "Fecha solución",
      "timeElapsed": "Tiempo de solución",
      "daysElapsed": "Días transcurridos",
      "status": "Estatus",
      "requestNumber": "# Solicitud",
      "creatorFullName": "Usuario creador",
      "priorityName": "Prioridad",
      "solutionUser": "Usuario solucionador",
      "supplierAssigned": "Usuario asignado",
      "type": "Tipo",
      "AssignmentType": "Tipo de asignación"
    },
    "header": {
      "title": "Folios",
      "toggle": {
        "list": "Listado",
        "indicators": "Indicadores"
      }
    },
  },
  "newDashboard": {
    "header": {
      "title": "Listado de folios",
      "toggle": {
        "list": "Listado",
        "indicators": "Indicadores"
      }
    },
    "btnsHeader": {
      "download": "Descargar",
      "reasign": "Reasignar",
      "delete": "Eliminar",
      "cancel": "Cancelar",
      "inPdf": "Folios en PDF",
      "inWord": "Folios en Word",
      "inExcel": "Folios en Excel",
      "resumenFolios": "Resumen de folios",
      "summaryFolio": "Resumen de folios",
      "guard": "Preventivo",
      "corrective": "Correctivo"
    },
    "btnsDescription": {
      "guard": "Programa mantenimientos preventivos",
      "corrective": "Crea mantenimientos correctivos",
      title: "Creación de folio",
      description: "Seleccione el tipo de folio para continuar"
    }
  },
  "setting": {
    "generateFolioInform" : "Generando descarga del resumen de folios",
    "limitFolio": "Limitar cantidad de folios",
    "maxRejects": "Máximo número de rechazos",
    "maxRejections": "Cantidad máxima de rechazos",
    "enableSurvey": "¿Habilitar encuesta de satisfacción al cliente?",
    "mandatorySurvey": "Encuesta obligatoria",
    "satisfactionQuestion": "Pregunta de satisfacción al cliente",
    "createdBy": "Creada por",
    "updatedBy": "Actualizado por",
    "createdAt": "Fecha de creación",
    "departments": "# de Departamentos"
  },
  "folios": "Folios",
  amountFolios: "Cantidad de folios",
  "requested": "Solicitados",
  "toBeAttended": "Por atender",
  reassignUser: {
    title: 'Reasignar usuarios'
  },
  tabList: {
    reassign: 'Reasignar',
    tracking: 'Seguimiento'
  },
  reassign: {
    title: 'Seleccione el usuario al que desea reasignar el folio'
  },
  tracking: {
    tableTitle: 'Usuarios que pueden dar seguimiento al folio',
    bossCanFollowUp: 'El jefe directo puede dar seguimiento',
    snackbar: {
      success: "El seguimiento se ha agregado exitósamente."
    }
  },
  table: {
    name: 'Nombre',
    curp: 'CURP',
    role: 'Rol',
    userType: 'Tipo de usuario',
    division: 'División',
    reassignTo: 'Reasignar a'
  },
  "notificationCenter": {
    "applyConfiguration": "Aplicar configuración",
    "notificationCenterByFolio": "Centro de notificaciones de folio",
    "notificationSummarySendingSettings": "Configuración de envío de resumen de notificaciones",
    "configureTheWayAndFrequencyToSendNotificationSummary": "Configure la forma y frecuencia en la que desea que se envíen el resumen de notificaciones pendientes y atendidas",
    "shippingChannels": "Canales de envío",
    "sendingFrequency": "Frecuencia de envío",
    "configureNotifications": "Configurar notificaciones",
    "indicateTheChannelsForUserNotifications": "Indique los canales a través de los cuales el usuario recibe las siguientes notificaciones: ",
    "notifications": "- Solicitud \n - Rechazo \n - Solucionado \n - Reasignado \n - Aprobado",
    "selectedUserWithCount_one": "{{count}} Usuario seleccionado",
    "selectedUserWithCount_other": "{{count}} Usuarios seleccionados",
    "configureUsers": "Se configuraron las notificaciones para los usuarios",
    "tabs": {
      "notification": "Config. de notificaciones",
      "users": "Config. de usuarios"
    },
    "channelSending": {
      "email": "Correo electrónico",
      "mobileApplication": "Aplicación móvil"
    },
    "frequencySending": {
      "endOfTheDay": "Al final del día",
      "everyThreeDays": "Cada tres días (Lunes, Miércoles, Viernes)",
      "everyWeek": "Cada semana"
    },
    "snackBar": {
      "create": {
        "success": "La configuración se creó correctamente",
        "error": "Ocurrió un error y no se pudo crear la configuración"
      },
      "update": {
        "success": "La configuración se actualizó correctamente",
        "error": "Ocurrió un error y no se pudo actualizar la configuración"
      },
      "updateUsers": {
        "success": "Se actualizó correctamente la configuración de notificaciones para los usuarios",
        "error": "Ocurrió un error y no se pudo actualizar la configuración de notificaciones para los usuarios",
      }
    }
  },
  forms: {
    correctiveMaintenance: "Nueva solicitud de mantenimiento Correctivo",
    correctiveMaintenanceEdit: "Edición de mantenimiento correctivo",
    preventiveMaintenance: "Nueva solicitud de mantenimiento Preventivo",
    preventiveMaintenanceEdit: "Edición de mantenimiento preventivo",
    classificationOfTheApplication: "Clasificación de la solicitud",
    MostFrecuenceSelection: "Tus opciones más frecuentes",
    selectCategories: "Seleccione una categoría",
    categoriesSelected: "Categorías agregadas",
    noCategoriesSelected: "Debes seleccionar al menos una categoría/servicio para crear el folio",
    back: "Regresar",
    continue: "Continuar"
  }

}